import axios from 'axios'

import { mergeConfig } from 'services/APIService'
import {
  getSrqDiagnosticsApiParams,
  SrqDiagnosticsApiParams
} from 'modules/quizDiagnostics/utils/getSrqApiParams'

const apiUrl = process.env.REACT_APP_API_URL

/** Isolated client so quiz-diagnostics errors do not trigger global /not-found redirect */
const quizDiagnosticsApi = axios.create({ baseURL: apiUrl })

export const fetchQuizDiagnostics = (
  params: SrqDiagnosticsApiParams = getSrqDiagnosticsApiParams()
) =>
  quizDiagnosticsApi.get(
    '/ai-spaced-repetition-quiz/diagnostics',
    mergeConfig({ params })
  )

export const fetchQuizDiagnosticsChapter = (
  studentBookChapterId: string,
  params: SrqDiagnosticsApiParams = getSrqDiagnosticsApiParams()
) =>
  quizDiagnosticsApi.get(
    `/ai-spaced-repetition-quiz/diagnostics/chapter/${studentBookChapterId}`,
    mergeConfig({ params })
  )

export type ChapterSectionSrqRedDotsPayload = {
  sections: Array<{
    student_book_subchapter_id: string
    visible: boolean
  }>
  timezone: string
}

export const updateChapterSectionsSrqRedDots = (
  studentBookChapterId: string,
  payload: ChapterSectionSrqRedDotsPayload
) =>
  quizDiagnosticsApi.put(
    `/ai-spaced-repetition-quiz/diagnostics/chapter/${studentBookChapterId}/srq-red-dots`,
    payload,
    mergeConfig({})
  )
